const expand = function(element, parent, newElId, elType = 'div') {

  return new Promise ( function(resolve, reject) {

    if(!document.getElementById(newElId)){
      let newElement = document.createElement(elType);
      newElement.id = newElId;

      //get element coords
      let elementCoords = element.getBoundingClientRect();
      newElement.style.top = elementCoords.top + 'px';
      newElement.style.left = elementCoords.left + 'px';
      newElement.style.width = elementCoords.width + 'px';
      newElement.style.height = elementCoords.height + 'px';
      //get/set element bgcolor
      let bgcolor = window.getComputedStyle(element).backgroundColor;
      newElement.style.backgroundColor = bgcolor;
      schedule.appendChild(newElement);

      setTimeout(function(){
        //add full class to expand to position
        newElement.classList.add('full');
        setTimeout( function(){
          resolve(newElement);
        }, 600);
      }, 100);
    }
  });
}

export default expand;
